// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__f64 {
  position: relative;
  display: inline-flex;
  align-items: start;
  background-color: var(--ring-sidebar-background-color);
  border: 1px solid var(--ring-border-disabled-color);
  border-radius: var(--ring-border-radius);
  padding: 0 4px;
  box-sizing: border-box;
}

.containerSizeFull__cc1 {
  width: 100%;
}

.containerSizeAuto__e88 {
  width: min-content;
  max-width: 100%;
}

.containerSizeS__e3f {
  width: calc(var(--ring-unit) * 12);
}

.containerSizeM__b50 {
  width: calc(var(--ring-unit) * 30);
}

.containerSizeL__e42 {
  width: calc(var(--ring-unit) * 50);
}

.container__f64:hover:not(.disabled__f1c):not(:has(.downloadBtn__a62:hover)) {
  border: 1px solid var(--ring-borders-color);

  .copyBtn__ce7 svg {
    color: var(--ring-icon-hover-color);
    transition: color 0.1s ease-in-out;
  }
}

.clickable__db5 {
  cursor: pointer;
}

.text__faa.text__faa {
  margin: 2px;
  max-width: calc(100% - var(--ring-unit) * 4);
  overflow: auto;
  display: flex;
  align-items: center;
  cursor: default;
}

.text__faa.text__faa > code {
  line-height: var(--ring-line-height-taller);
  padding: 4px;
}

.text__faa.text__faa:not(.inlineText__ae5) > code {
  word-wrap: anywhere;
  white-space: break-spaces;
}

.disabled__f1c .text__faa {
  --ring-code-color: var(--ring-disabled-color);
}

.inlineText__ae5.inlineText__ae5 > code {
  white-space: nowrap;
}

.actions__a41 {
  position: absolute;
  top: calc(var(--ring-unit) * 0.85);
  right: calc(var(--ring-unit) * 0.85);

  display: flex;
  justify-content: center;
  align-items: center;
  gap: calc(var(--ring-unit) * 2);
}
`, "",{"version":3,"sources":["webpack://./src/common/clipboard/copied-code/copied-code.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,sDAAsD;EACtD,mDAAmD;EACnD,wCAAwC;EACxC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;;EAE3C;IACE,mCAAmC;IACnC,kCAAkC;EACpC;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,oCAAoC;;EAEpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;AACjC","sourcesContent":[".container {\n  position: relative;\n  display: inline-flex;\n  align-items: start;\n  background-color: var(--ring-sidebar-background-color);\n  border: 1px solid var(--ring-border-disabled-color);\n  border-radius: var(--ring-border-radius);\n  padding: 0 4px;\n  box-sizing: border-box;\n}\n\n.containerSizeFull {\n  width: 100%;\n}\n\n.containerSizeAuto {\n  width: min-content;\n  max-width: 100%;\n}\n\n.containerSizeS {\n  width: calc(var(--ring-unit) * 12);\n}\n\n.containerSizeM {\n  width: calc(var(--ring-unit) * 30);\n}\n\n.containerSizeL {\n  width: calc(var(--ring-unit) * 50);\n}\n\n.container:hover:not(.disabled):not(:has(.downloadBtn:hover)) {\n  border: 1px solid var(--ring-borders-color);\n\n  .copyBtn svg {\n    color: var(--ring-icon-hover-color);\n    transition: color 0.1s ease-in-out;\n  }\n}\n\n.clickable {\n  cursor: pointer;\n}\n\n.text.text {\n  margin: 2px;\n  max-width: calc(100% - var(--ring-unit) * 4);\n  overflow: auto;\n  display: flex;\n  align-items: center;\n  cursor: default;\n}\n\n.text.text > code {\n  line-height: var(--ring-line-height-taller);\n  padding: 4px;\n}\n\n.text.text:not(.inlineText) > code {\n  word-wrap: anywhere;\n  white-space: break-spaces;\n}\n\n.disabled .text {\n  --ring-code-color: var(--ring-disabled-color);\n}\n\n.inlineText.inlineText > code {\n  white-space: nowrap;\n}\n\n.actions {\n  position: absolute;\n  top: calc(var(--ring-unit) * 0.85);\n  right: calc(var(--ring-unit) * 0.85);\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: calc(var(--ring-unit) * 2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__f64`,
	"containerSizeFull": `containerSizeFull__cc1`,
	"containerSizeAuto": `containerSizeAuto__e88`,
	"containerSizeS": `containerSizeS__e3f`,
	"containerSizeM": `containerSizeM__b50`,
	"containerSizeL": `containerSizeL__e42`,
	"disabled": `disabled__f1c`,
	"downloadBtn": `downloadBtn__a62`,
	"copyBtn": `copyBtn__ce7`,
	"clickable": `clickable__db5`,
	"text": `text__faa`,
	"inlineText": `inlineText__ae5`,
	"actions": `actions__a41`
};
export default ___CSS_LOADER_EXPORT___;
